import { c as _c } from "react/compiler-runtime";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { useWaveDecisions } from "@/hooks/waves/useWaveDecisions";
import { getRenderableWaveDecisionWinners } from "@/helpers/waves/wave-decision.helpers";
type NextMintDropState = {
  readonly nextMint: ApiDrop | null;
  readonly nextMintTitle: string | null;
  readonly waveId: string | null;
  readonly isReady: boolean;
  readonly isSettingsLoaded: boolean;
  readonly isFetching: boolean;
};
export const useNextMintDrop = () => {
  const $ = _c(13);
  const {
    seizeSettings,
    isLoaded
  } = useSeizeSettings();
  const waveId = seizeSettings.memes_wave_id;
  const t0 = waveId ?? "";
  const t1 = !!waveId;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = {
      waveId: t0,
      enabled: t1
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    decisionPoints,
    isFetching
  } = useWaveDecisions(t2);
  const latestDecision = decisionPoints[decisionPoints.length - 1];
  let nextMint;
  let t3;
  if ($[3] !== latestDecision?.winners) {
    nextMint = getRenderableWaveDecisionWinners(latestDecision?.winners ?? [])[0]?.drop ?? null;
    t3 = nextMint?.title ?? nextMint?.metadata.find(_temp)?.data_value ?? null;
    $[3] = latestDecision?.winners;
    $[4] = nextMint;
    $[5] = t3;
  } else {
    nextMint = $[4];
    t3 = $[5];
  }
  const nextMintTitle = t3;
  const t4 = isLoaded && !!waveId;
  const t5 = isFetching || !isLoaded && !!waveId;
  let t6;
  if ($[6] !== isLoaded || $[7] !== nextMint || $[8] !== nextMintTitle || $[9] !== t4 || $[10] !== t5 || $[11] !== waveId) {
    t6 = {
      nextMint,
      nextMintTitle,
      waveId,
      isReady: t4,
      isSettingsLoaded: isLoaded,
      isFetching: t5
    };
    $[6] = isLoaded;
    $[7] = nextMint;
    $[8] = nextMintTitle;
    $[9] = t4;
    $[10] = t5;
    $[11] = waveId;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
function _temp(m) {
  return m.data_key === "title";
}